import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-locate-address-dialog',
  templateUrl: './locate-address.component.html',
  styleUrls: ['./locate-address.component.scss'],
})
export class LocateAddressComponent {
  address = '';

  constructor(
    public dialogRef: MatDialogRef<LocateAddressComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any | null
  ) {
  }

  confirm(): void {
    this.dialogRef.close(this.address);
  }
}
